import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { RoleMenuConfigService, CLE_STOCKAGE_MENUS_ROLE } from 'src/app/core/services/role-menu-config.service';
import { SidebarCollapseService } from 'src/app/core/services/sidebar-collapse.service';

const MENUS_CONFIGURABLES = new Set([
  'dashboard', 'zone-manager-espace', 'commandes', 'commandes-urbain', 'commandes-interurbain',
  'nouvelle-commande', 'utilisateurs', 'nouvel-utilisateur',
  'tarifs', 'configuration-tarifaire', 'zones', 'trajets', 'parametres', 'notifications',
  'livreur-commandes', 'livreur-mon-bilan', 'livreur-fiches-paie', 'partenaires', 'partenaires-liste', 'partenaires-nouveau',
  'manifestes', 'depotage',
  'utilisateurs-tous', 'utilisateurs-livreurs', 'utilisateurs-gestionnaires', 'utilisateurs-comptables',
  'clients', 'clients-liste', 'clients-standards', 'clients-contrat', 'comptabilite', 'mes-livreurs', 'rapports',
  'materiel', 'materiel-liste', 'materiel-alertes',
  'rh', 'rh-personnel', 'rh-primes', 'rh-conges', 'rh-configuration',
  'contrats', 'contrats-liste',
  'comptabilite-dashboard', 'comptabilite-factures-dynamiques',
  'config-niveaux-livreur',
  'suivi-live', 'reclamations', 'caisse', 'planning',
  'kanban-dispatch', 'finances-dashboard', 'creances-b2b',
  'maintenance-materiel', 'materiel-affectations', 'evaluations-livreurs', 'fiches-paie-livreurs',
  'config-villes', 'config-centres-tri', 'devis', 'config-faq'
]);

interface ElementMenu {
  divider?: boolean;
  sectionLabel?: string;
  icone?: string;
  libelle?: string;
  route?: string;
  queryParams?: Record<string, any>;
  roles?: string[];
  idMenu?: string;
  enfants?: ElementMenu[];
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  titreSidebar = 'Dematral Express';
  sousTitreSidebar = 'Administration';

  collapsed = false;
  sousMenuOuvert: string | null = 'commandes'; // ouvert par défaut

  tousMenus: ElementMenu[] = [

    // ── OPÉRATIONS ─────────────────────────────────────────────
    { divider: true, sectionLabel: 'Opérations', roles: ['ADMIN', 'MANAGER', 'USER', 'LIVREUR', 'RESPONSABLE_ZONE'] },
    { icone: 'fal fa-tachometer-alt', libelle: 'Dashboard',       route: '/dashboard',              roles: ['ADMIN', 'MANAGER', 'USER', 'LIVREUR'], idMenu: 'dashboard' },
    { icone: 'fal fa-map-marked-alt', libelle: 'Mon espace zone', route: '/zone-manager/dashboard', roles: ['RESPONSABLE_ZONE'], idMenu: 'zone-manager-espace' },
    {
      icone: 'fal fa-motorcycle', libelle: 'Espace livreur', route: '/livreur/mes-commandes',
      roles: ['LIVREUR'], idMenu: 'livreur-commandes',
      enfants: [
        { icone: 'fal fa-box-check',          libelle: 'Mes commandes',      route: '/livreur/mes-commandes',   roles: ['LIVREUR'], idMenu: 'livreur-commandes' },
        { icone: 'fal fa-chart-bar',          libelle: 'Mon bilan',          route: '/livreur/mon-bilan',       roles: ['LIVREUR'], idMenu: 'livreur-mon-bilan' },
        { icone: 'fal fa-file-invoice-dollar',libelle: 'Mes fiches de paie', route: '/livreur/mes-fiches-paie', roles: ['LIVREUR'], idMenu: 'livreur-fiches-paie' },
      ]
    },
    {
      icone: 'fal fa-box-open', libelle: 'Commandes', route: '/commande/lister',
      roles: ['ADMIN', 'MANAGER', 'USER', 'RESPONSABLE_ZONE'], idMenu: 'commandes',
      enfants: [
        { icone: 'fal fa-city',  libelle: 'Urbain',      route: '/commande/lister',      roles: ['ADMIN', 'MANAGER', 'USER', 'RESPONSABLE_ZONE'], idMenu: 'commandes-urbain' },
        { icone: 'fal fa-route', libelle: 'Interurbain', route: '/commande/interurbain', roles: ['ADMIN', 'MANAGER', 'USER', 'RESPONSABLE_ZONE'], idMenu: 'commandes-interurbain' },
      ]
    },
    { icone: 'fal fa-layer-group',    libelle: 'Dépôt & Tri',           route: '/commande/depotage',   roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'depotage' },
    { icone: 'fal fa-clipboard-list', libelle: 'Manifestes',             route: '/manifeste/lister',    roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'manifestes' },
    { icone: 'fal fa-map-pin',        libelle: 'Suivi en temps réel',    route: '/suivi-live',          roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'suivi-live' },
    { icone: 'fal fa-th-large',       libelle: 'Kanban Dispatch',        route: '/commandes/kanban',    roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'kanban-dispatch' },
    { icone: 'fal fa-exclamation-circle', libelle: 'Réclamations & Litiges', route: '/reclamations',   roles: ['ADMIN', 'MANAGER', 'USER', 'RESPONSABLE_ZONE'], idMenu: 'reclamations' },

    // ── FINANCES ───────────────────────────────────────────────
    { divider: true, sectionLabel: 'Finances', roles: ['ADMIN', 'MANAGER', 'COMPTABLE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'] },
    {
      icone: 'fal fa-calculator', libelle: 'Comptabilité', route: '/comptabilite/dashboard',
      roles: ['ADMIN', 'MANAGER', 'COMPTABLE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'comptabilite',
      enfants: [
        { icone: 'fal fa-chart-line',   libelle: 'Tableau de bord',     route: '/comptabilite/dashboard', roles: ['ADMIN', 'MANAGER', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'comptabilite-dashboard' },
        { icone: 'fal fa-file-invoice', libelle: 'Factures dynamiques', route: '/facturation/libres',     roles: ['ADMIN', 'MANAGER', 'COMPTABLE', 'COMPTABLE_GENERAL', 'COMPTABLE_ZONE'], idMenu: 'comptabilite-factures-dynamiques' },
      ]
    },
    { icone: 'fal fa-chart-line',         libelle: 'Dashboard financier',   route: '/finances/dashboard', roles: ['ADMIN', 'MANAGER', 'COMPTABLE_GENERAL'], idMenu: 'finances-dashboard' },
    { icone: 'fal fa-file-exclamation',   libelle: 'Créances B2B',          route: '/creances',           roles: ['ADMIN', 'MANAGER', 'COMPTABLE_GENERAL', 'COMPTABLE_ZONE'], idMenu: 'creances-b2b' },
    { icone: 'fal fa-chart-pie',          libelle: 'Rapports & indicateurs', route: '/rapports',          roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'rapports' },
    { icone: 'fal fa-cash-register',      libelle: 'Caisse & Encaissements', route: '/caisse',            roles: ['ADMIN', 'MANAGER', 'COMPTABLE', 'COMPTABLE_GENERAL', 'COMPTABLE_ZONE'], idMenu: 'caisse' },
    { icone: 'fal fa-file-invoice-dollar',libelle: 'Fiches de paie',        route: '/fiches-paie',        roles: ['ADMIN', 'MANAGER', 'COMPTABLE_GENERAL', 'COMPTABLE'], idMenu: 'fiches-paie-livreurs' },

    // ── CLIENTS & PARTENAIRES ──────────────────────────────────
    { divider: true, sectionLabel: 'Clients & Partenaires', roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL', 'GESTIONNAIRE_PARTENARIATS', 'COMPTABLE'] },
    {
      icone: 'fal fa-user-friends', libelle: 'Clients', route: '/clients/liste',
      roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'clients',
      enfants: [
        { icone: 'fal fa-list',           libelle: 'Tous les clients',     route: '/clients/liste',      roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'clients-liste' },
        { icone: 'fal fa-user',           libelle: 'Clients standards',    route: '/utilisateur/lister', queryParams: { scope: 'clients-standards' }, roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'clients-standards' },
        { icone: 'fal fa-file-signature', libelle: 'Clients sous contrat', route: '/utilisateur/lister', queryParams: { scope: 'clients-contrat'   }, roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'COMPTABLE_ZONE', 'COMPTABLE_GENERAL'], idMenu: 'clients-contrat' }
      ]
    },
    {
      icone: 'fal fa-handshake', libelle: 'Partenaires', route: '/partenaires/liste',
      roles: ['ADMIN', 'MANAGER', 'GESTIONNAIRE_PARTENARIATS'], idMenu: 'partenaires',
      enfants: [
        { icone: 'fal fa-list',        libelle: 'Liste des partenaires', route: '/partenaires/liste',   roles: ['ADMIN', 'MANAGER', 'GESTIONNAIRE_PARTENARIATS'], idMenu: 'partenaires-liste' },
        { icone: 'fal fa-plus-circle', libelle: 'Ajouter un partenaire', route: '/partenaires/nouveau', roles: ['ADMIN'],                                         idMenu: 'partenaires-nouveau' },
      ]
    },
    {
      icone: 'fal fa-file-contract', libelle: 'Contrats B2B', route: '/contrats',
      roles: ['ADMIN', 'MANAGER', 'GESTIONNAIRE_PARTENARIATS', 'COMPTABLE'], idMenu: 'contrats',
      enfants: [
        { icone: 'fal fa-list', libelle: 'Tous les contrats', route: '/contrats', roles: ['ADMIN', 'MANAGER', 'GESTIONNAIRE_PARTENARIATS', 'COMPTABLE'], idMenu: 'contrats-liste' },
      ]
    },
    { icone: 'fal fa-file-search', libelle: 'Demandes de devis', route: '/devis', roles: ['ADMIN', 'MANAGER'], idMenu: 'devis' },

    // ── ÉQUIPE ─────────────────────────────────────────────────
    { divider: true, sectionLabel: 'Équipe', roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'RESPONSABLE_RH', 'COMPTABLE'] },
    {
      icone: 'fal fa-users', libelle: 'Utilisateurs', route: '/utilisateur/lister',
      roles: ['ADMIN', 'MANAGER'], idMenu: 'utilisateurs',
      enfants: [
        { icone: 'fal fa-list',       libelle: 'Tous',                 route: '/utilisateur/lister', queryParams: { scope: 'tous'          }, roles: ['ADMIN', 'MANAGER'], idMenu: 'utilisateurs-tous' },
        { icone: 'fal fa-motorcycle', libelle: 'Livreurs',             route: '/utilisateur/lister', queryParams: { scope: 'livreurs'      }, roles: ['ADMIN', 'MANAGER'], idMenu: 'utilisateurs-livreurs' },
        { icone: 'fal fa-map-pin',    libelle: 'Resp. de zone',        route: '/utilisateur/lister', queryParams: { scope: 'gestionnaires' }, roles: ['ADMIN', 'MANAGER'], idMenu: 'utilisateurs-gestionnaires' },
        { icone: 'fal fa-calculator', libelle: 'Comptables',           route: '/utilisateur/lister', queryParams: { scope: 'comptables'    }, roles: ['ADMIN', 'MANAGER'], idMenu: 'utilisateurs-comptables' }
      ]
    },
    { icone: 'fal fa-motorcycle',   libelle: 'Mes Livreurs',              route: '/utilisateur/lister', queryParams: { scope: 'livreurs' }, roles: ['RESPONSABLE_ZONE'], idMenu: 'mes-livreurs' },
    { icone: 'fal fa-calendar-alt', libelle: 'Planning & Disponibilités', route: '/planning',   roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE', 'RESPONSABLE_RH'], idMenu: 'planning' },
    { icone: 'fal fa-star-half-alt',libelle: 'Évaluations livreurs',     route: '/evaluations', roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'evaluations-livreurs' },
    {
      icone: 'fal fa-users-cog', libelle: 'Ressources Humaines', route: '/rh',
      roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_RH', 'COMPTABLE'], idMenu: 'rh',
      enfants: [
        { icone: 'fal fa-id-card',        libelle: 'Fiches RH',         route: '/rh/personnel',     roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_RH'],              idMenu: 'rh-personnel' },
        { icone: 'fal fa-gift',           libelle: 'Primes mensuelles', route: '/rh/primes',        roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_RH', 'COMPTABLE'], idMenu: 'rh-primes' },
        { icone: 'fal fa-umbrella-beach', libelle: 'Congés & Absences', route: '/rh/conges',        roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_RH'],              idMenu: 'rh-conges' },
        { icone: 'fal fa-sliders-h',      libelle: 'Configuration RH',  route: '/rh/configuration', roles: ['ADMIN', 'RESPONSABLE_RH'],                         idMenu: 'rh-configuration' },
      ]
    },

    // ── ACTIFS ─────────────────────────────────────────────────
    { divider: true, sectionLabel: 'Actifs', roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'] },
    {
      icone: 'fal fa-tools', libelle: 'Matériel & Flotte', route: '/materiel',
      roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'], idMenu: 'materiel',
      enfants: [
        { icone: 'fal fa-list-ul',              libelle: 'Inventaire',            route: '/materiel',                                     roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'], idMenu: 'materiel-liste' },
        { icone: 'fal fa-link',                 libelle: 'Affectations livreurs', route: '/materiel', queryParams: { tab: 'affectations' }, roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'], idMenu: 'materiel-affectations' },
        { icone: 'fal fa-exclamation-triangle', libelle: 'Alertes documents',     route: '/materiel', queryParams: { tab: 'alertes' },      roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'], idMenu: 'materiel-alertes' },
        { icone: 'fal fa-calendar-check',       libelle: 'Planning maintenance',  route: '/maintenance',                                  roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_MATERIEL'], idMenu: 'maintenance-materiel' },
      ]
    },

    // ── CONFIGURATION ──────────────────────────────────────────
    { divider: true, sectionLabel: 'Configuration', roles: ['ADMIN', 'MANAGER'] },
    { icone: 'fal fa-tags',           libelle: 'Tarifs',                route: '/tarif/configuration/lister',          roles: ['ADMIN', 'MANAGER'], idMenu: 'tarifs' },
    { icone: 'fal fa-map',            libelle: 'Zones',                 route: '/zone/lister',                         roles: ['ADMIN', 'MANAGER'], idMenu: 'zones' },
    { icone: 'fal fa-route',          libelle: 'Trajets',               route: '/trajet/lister',                       roles: ['ADMIN', 'MANAGER'], idMenu: 'trajets' },
    { icone: 'fal fa-city',           libelle: 'Villes',                route: '/configuration/villes',                roles: ['ADMIN', 'MANAGER'], idMenu: 'config-villes' },
    { icone: 'fal fa-warehouse',      libelle: 'Centres de tri',        route: '/configuration/centres-tri',           roles: ['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'], idMenu: 'config-centres-tri' },
{ icone: 'fal fa-medal',          libelle: 'Niveaux livreur',       route: '/configuration/niveaux-livreur',       roles: ['ADMIN', 'MANAGER'], idMenu: 'config-niveaux-livreur' },
    { icone: 'fal fa-question-circle',libelle: 'FAQ',                   route: '/configuration/faq',                   roles: ['ADMIN', 'MANAGER'], idMenu: 'config-faq' },
    { icone: 'fal fa-shield-alt',     libelle: 'Gestion des rôles',     route: '/gestion-roles',                       roles: ['ADMIN'],            idMenu: 'gestion-roles' },

    // ── COMPTE ─────────────────────────────────────────────────
    { divider: true, sectionLabel: 'Compte', roles: ['ADMIN', 'MANAGER', 'USER', 'LIVREUR', 'RESPONSABLE_ZONE', 'RESPONSABLE_MATERIEL', 'RESPONSABLE_RH', 'COMPTABLE', 'GESTIONNAIRE_PARTENARIATS'] },
    { icone: 'fal fa-user-circle', libelle: 'Mon profil', route: '/profil',     roles: ['ADMIN', 'MANAGER', 'USER', 'LIVREUR', 'RESPONSABLE_ZONE', 'RESPONSABLE_MATERIEL', 'RESPONSABLE_RH', 'COMPTABLE', 'GESTIONNAIRE_PARTENARIATS'], idMenu: 'profil' },
    { icone: 'fal fa-cog',         libelle: 'Paramètres', route: '/parametres', roles: ['ADMIN'], idMenu: 'parametres' }
  ];

  elementsMenu: ElementMenu[] = [];
  roleUtilisateur: string = '';

  constructor(
    private authService: AuthService,
    private roleMenuConfigService: RoleMenuConfigService,
    private sidebarCollapse: SidebarCollapseService
  ) {}

  ngOnInit(): void {
    this.chargerMenusSelonRole();
    this.collapsed = this.sidebarCollapse.collapsed;
    document.body.classList.toggle('sidebar-collapsed', this.collapsed);
    this.sidebarCollapse.collapsed$.subscribe(v => {
      this.collapsed = v;
    });

    this.authService.connexionStatusObservable.subscribe(connecte => {
      if (connecte) {
        setTimeout(() => this.chargerMenusSelonRole(), 100);
      } else {
        this.elementsMenu = [];
      }
    });

    this.roleMenuConfigService.surConfigMiseAJour.subscribe(() => {
      this.chargerMenusSelonRole();
    });
  }

  chargerMenusSelonRole(): void {
    const utilisateurCourant = this.authService.obtenirUtilisateurCourant();

    if (utilisateurCourant && utilisateurCourant.role) {
      this.roleUtilisateur = utilisateurCourant.role;
      const menusRolePersonnalises = this.obtenirMenusPersonnalisesPourRole(this.roleUtilisateur);

      const filtrés = this.tousMenus.filter(menu => {
        if (menu.divider) return true; // retiré ensuite si orphelin
        if (!menu.roles || menu.roles.length === 0) return true;
        if (!menu.roles.includes(this.roleUtilisateur)) return false;
        if (menu.idMenu && MENUS_CONFIGURABLES.has(menu.idMenu) && menusRolePersonnalises && menusRolePersonnalises.length > 0) {
          return menusRolePersonnalises.includes(menu.idMenu);
        }
        return true;
      });

      // Supprime les dividers sans items après eux (ou consécutifs)
      this.elementsMenu = filtrés.filter((item, idx) => {
        if (!item.divider) return true;
        const suivant = filtrés[idx + 1];
        return suivant && !suivant.divider;
      });
    } else {
      this.elementsMenu = this.tousMenus.filter(menu => !menu.divider && (!menu.roles || menu.roles.length === 0));
    }
  }

  private obtenirMenusPersonnalisesPourRole(nomRole: string): string[] | null {
    try {
      const brut = localStorage.getItem(CLE_STOCKAGE_MENUS_ROLE);
      if (!brut) return null;
      const donnees: Record<string, string[]> = JSON.parse(brut);
      return donnees[nomRole] ?? null;
    } catch {
      return null;
    }
  }

  obtenirLibelleRole(): string {
    const correspondanceRoles: { [cle: string]: string } = {
      'ADMIN': 'Administrateur',
      'MANAGER': 'Manager',
      'USER': 'Utilisateur',
      'LIVREUR': 'Livreur',
      'RESPONSABLE_ZONE': 'Resp. de zone',
      'GESTIONNAIRE_ZONE': 'Resp. de zone',
      'COMPTABLE_ZONE': 'Comptable zone',
      'COMPTABLE_GENERAL': 'Comptable général'
    };
    return correspondanceRoles[this.roleUtilisateur] || 'Utilisateur';
  }

  toggleReplie(): void {
    this.sidebarCollapse.toggle();
  }

  toggleSousMenu(idMenu: string | undefined): void {
    if (!idMenu) return;
    this.sousMenuOuvert = this.sousMenuOuvert === idMenu ? null : idMenu;
  }

  aSousMenu(element: ElementMenu): boolean {
    return !!(element.enfants && element.enfants.length > 0);
  }
}
